var FusePipesModule = /** @class */ (function () {
    function FusePipesModule() {
    }
    return FusePipesModule;
}());
export { FusePipesModule };
